import { createReducer } from 'reduxsauce';
import update from 'immutability-helper';

import { SigninManagerFormTypes } from '../actions/signinManagerForm';

const INITIAL_STATE = {
  email: {},
  password: {},
};

const resetSigninManagerForm = (state = INITIAL_STATE) => update(state, {
  email: { $set: INITIAL_STATE.email },
  password: { $set: INITIAL_STATE.password },
});

const updateSigninManagerField = (state = INITIAL_STATE, { field }) => update(state, {
  [field.name]: {
    value: { $set: field.value },
    error: { $set: field.error },
  },
});

export default createReducer(INITIAL_STATE, {
  [SigninManagerFormTypes.RESET_SIGNIN_MANAGER_FORM]: resetSigninManagerForm,
  [SigninManagerFormTypes.UPDATE_SIGNIN_MANAGER_FIELD]: updateSigninManagerField,
});
